export default __webpack_public_path__ + "static/media/hortifruti-600x600.82e3c4aa.jpg";